import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { AppConfig } from '../types';
import { api } from '../utils/api';

interface ConfigContextType {
  config: AppConfig | null;
  loading: boolean;
  showPrices: boolean;
}

const ConfigContext = createContext<ConfigContextType | undefined>(undefined);

export const ConfigProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [config, setConfig] = useState<AppConfig | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const data = await api.getConfig();
        setConfig(data);
      } catch (error) {
        console.error('Failed to load configuration:', error);
        // Set default config on error
        setConfig({
          appName: 'Cleaning Services Platform',
          version: '1.0.0',
          features: {
            showPrices: true
          }
        });
      } finally {
        setLoading(false);
      }
    };

    fetchConfig();
  }, []);

  const showPrices = config?.features?.showPrices ?? true;

  return (
    <ConfigContext.Provider value={{ config, loading, showPrices }}>
      {children}
    </ConfigContext.Provider>
  );
};

export const useConfig = () => {
  const context = useContext(ConfigContext);
  if (context === undefined) {
    throw new Error('useConfig must be used within a ConfigProvider');
  }
  return context;
};
